import { jsPDF } from 'jspdf';

import { Slide } from '../../components/SlideComponents/slide.types';
import {
  POLL_BAR_Y_OFFSET,
  POLL_OPTION_GAP,
  POLL_OPTION_PADDING_RATIO,
  POLL_Y_POSITION_RATIO,
} from './constants';
import renderTextElement from './renderTextElement';
import { addPollLine, parseJSON, parseRGB } from './utils';

export const addPollOptions = async (pdf: jsPDF, slide: Slide) => {
  if (!slide.pollOptions) return;

  const yPosition = slide.height * POLL_Y_POSITION_RATIO;
  const padding = slide.width * POLL_OPTION_PADDING_RATIO;
  const totalWidth = slide.width - padding * 2;
  const gapWidth = POLL_OPTION_GAP - slide.pollOptions.length;
  const optionWidth = totalWidth / slide.pollOptions.length - gapWidth;
  const barWidth = optionWidth - gapWidth;

  for (let i = 0; i < slide.pollOptions.length; ++i) {
    const option = slide.pollOptions[i];
    const xBarOffset = (optionWidth - barWidth) / 2;
    const xPosition = padding + (optionWidth + gapWidth) * i;
    const color = parseRGB(option.color || '') || [0, 0, 0];
    await addPollLine(
      pdf,
      xPosition + xBarOffset,
      yPosition - POLL_BAR_Y_OFFSET,
      barWidth,
      color,
    );

    await renderTextElement({
      pdf,
      x: xPosition,
      y: yPosition,
      width: optionWidth,
      textElements: parseJSON(option.displayName) ?? [],
    });
  }
};
